import FormFieldGroup from 'shared/src/form/FormFieldGroup'
import PropTypes from 'prop-types'
import { useState, useEffect, useCallback } from 'react'
import { titleText } from 'shared/src/form/FormFieldNumber'
//TODO: text validation

function FormTextArea(props){
    let [hasError, setErrorState] = useState(false)
    let [isFocused, setIsFocused] = useState(false)
    let [firstFocus, setfirstFocus] = useState(false) //Only run validation on fields that have already been visited
    
    const checkErrors = useCallback((value, force = false)=>{ //Use callback is the same as function.bind(this) need to bind it to the specific component
        if(!props.matchesRegex){
            return
        }
        if(value === undefined && !force){
            return
        }
        if(value === undefined){
            value = ""
        }
        let regex = getRegex(props.matchesRegex)
        if(!regex.test(value)){
            if(props.onFieldError && props.matchesRegex.type !== "warning"){
                props.onFieldError && props.onFieldError(props.name)
            }
            setErrorState(true)
            return;
        }
        if(props.onFieldError && props.matchesRegex.type !== "warning"){
            props.onFieldError && props.onFieldErrorCleared(props.name)
        }
        setErrorState(false)
    },[props])
    useEffect(()=>{
        if(props.forceErrorCheck === true){
            setfirstFocus(true)
            checkErrors(props.value, true)
        }
        else if(firstFocus){
            checkErrors(props.value)
        }
    },[props.matchesRegex,props.forceErrorCheck,checkErrors,firstFocus,props.value])

    const setFocus = useCallback((isfocused,e) => {
        !firstFocus && setfirstFocus(true)
        if(firstFocus && props.matchesRegex){
            checkErrors(e.target.value)
        }
        setIsFocused(isfocused)
    },[props, checkErrors, firstFocus])

    return(
        <FormFieldGroup
        title={props.title}
        className={"text-area "+((hasError ? "has-error" : "") + (isFocused ? " focused" : "") + (hasError && props.matchesRegex.type === "warning" ? " warning" : ""))}
        errorElement={hasError && <span className={`${!props.matchesRegex.type ? "error" : props.matchesRegex.type}`}>
            {!props.matchesRegex.message ? `Invalid ${titleText(props)} format`: props.matchesRegex.message}
        </span>}
        >
            <span className="symbol">
                {props.symbol}
            </span>
            <textarea
            type="text"
            name={props.name}
            value={props.value}
            onChange={(e)=> props.onChange(props.name,validatedText(e, props))}
            onBlur={(e)=>setFocus(false,e)}
            onFocus={(e)=>setFocus(true,e)}
            rows={props.rows || 2}
            />
        </FormFieldGroup>
    )
}

function validatedText(e, props){
    const m = props.maxChars || 1000
    const text= e.target.value
    if(text.length > m){
        e.target.value = text.substr(0,m)
    }
    return e
}

function getRegex(x){
    if(x instanceof RegExp){
        return x
    }
    if(x instanceof Object && x.regex){
        return getRegex(x.regex)
    }
    if(typeof x === "string"){
        return new RegExp(x)
    }
    return new RegExp(".*","g")
}

FormTextArea.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    matchesRegex: PropTypes.oneOfType([PropTypes.string,PropTypes.instanceOf(RegExp),PropTypes.exact({
        regex: PropTypes.oneOfType([PropTypes.string,PropTypes.instanceOf(RegExp)]),
        type: PropTypes.oneOf(["error","warning"]),
        message: PropTypes.string
    })]),
    onFieldError: PropTypes.func,
    onFieldErrorCleared: PropTypes.func,
    titleText: function(props){
        if(props['title'] && typeof (props['title']) !== "string" && !props['titleText']){
            return new Error(`You must provide a titleText prop if you are passing a node as a title: ${props.name}`)
        }
    },
    forceErrorCheck: PropTypes.bool, //This value is irrelevant, it triggers the checkerror function whenever the value changes
    maxChars: PropTypes.number
}


export default FormTextArea;